module.exports = __webpack_public_path__ + "media/images/icons/outlined/swap-a7aa6990993959d175e359921acbaccd.svg";